import exp from "constants";

export interface ImageInfo {
    id?: string;
    imageUrl: string;
    imageSize: string;
    subSection: string;
}

export interface CountryCurrency {
    id: number;
    countryCode: string;
    countryName: string;
    currencyName: string;
    currencyCode: string;
    symbol: string;
    hasOutlet? : boolean;
}

export interface PrintedTag {
    epc: string;
    sku: string;
}

export interface Brand {
    id: number;
    brandId?: number;
    levelOne: string;
    levelTwo: string;
    code: string;
}

export interface Mall {
    id: number;
    name: string;
    countryCurrencyId: number;
}

export interface Color {
    id: number;
    family: string;
    name: string;
    code: string;
    number: number;
}

export interface Warehouse {
    id: number;
    locationCode: string;
    levelOne: string;
    levelTwo: string;
    levelThree: string;
    levelFour: string;
    levelFive: string;
    levelSix: string;
    countryCurrencyId: number;
    countryId:number;
    itemTypeStored: string;
    maxCapacity: number;
}

export interface Supplier {
    id: number;
    code: string;
    name: string;
    brandId: number;
    countryId?: number; 
    currencyId?: number;
    brands?: Brand[];
}

export interface Store {
    id: number;
    mallId: number;
    name: string;
    code: string;
    size: string;
    address: string;
    mall:Mall;
    brands: StoreBrand[];
}
export interface StoreBrand {
    id: number;
    storeId: number;
    brandId: number;
    brands: Brand[];
}

export interface Location {
    id: number;
    name: string;
    type: string;
}

export interface ItemStyle {
    id: number;
    name: string;
}

export interface ItemSize {
    id: number;
    code: string;
    multiplier: number;
    isAutoSelected: boolean;
}

export interface ItemCategory {
    id: number;
    levelOne: number;
    levelTwo: string;
    name: string;
    code: string;
}

export interface ItemCategoryVariance {
    id: number;
    levelOne: string;
    variancePercentage:number;
    isActive:boolean;
}
export interface PriceCategory {
    id: number;
    name: string;
    countrySellPrices: ItemCountrySellPrice[];
}

export interface Collection {
    id: number;
    collectionName: string;
}

export interface ArticleDetails {
    itemName?: string;
    id?: number;
    brandCode?: string;
    brandId?: number;
    itemCategoryId?: number;
    categoryName?: string;
    itemStyleId?: number;
    itemStyleName?: string;
    number?: string;
    remarks?: string;
    sampleSource?: string;
    materialComposition?:string;
    materialNumber?:string;
    fabricUsage?:string
    supplierId?: number;
    supplierCode?: string;
    supplierItemCode?: string;
    tags?: TagArticle[];
    itemMasters?: ItemMaster[];
    isActive?: boolean;
}

export interface ItemMaster {
    itemMasterId: number;
    colorId: number;
    colorName: string;
    countryCurrencyId: number;
    costCurrency: string;
    costCurrencySymbol: string;
    costPrice: number;
    itemSizeId: number;
    priceCategoryId: number;
    priceCategoryName: string;
    size: string;
    skuCode: string;
    itemCountrySellPrices: ItemCountrySellPrice[];
    isActive: boolean;
    fabricSupplier:string;
    fabricColor:string;
    fabricNumber:string;
    fabricUnitCostCurrencyId:number;
    fabricUnitCostPrice:number;
    fabricUnitCostPriceWithSymbol?:string;
    imagePath : string;
    imageName : string;
    itemMasterImages?: ItemMasterImage[];
    imageIdsToRemove?:number[];

}
export interface ItemMasterImage {
    itemMasterImageId:number;
    articleId:number;
    colorId:number;
    imagePath:string;
    presignedImageUrl:string;
    isRemoved:boolean;
}

export interface ItemCountrySellPrice {
    itemCountrySellPriceId: number;
    countryCode: string;
    countryCurrencyId: number;
    symbol: string;
    price: number;
    sellPriceId?: number;
    countryName?: string;
}

export interface TagArticle {
    tagArticleId:number;
    tagId:number;
    name:string;
}

export interface Tag {
    id:number;
    name:string;
}

export interface ColorAndSize {
    itemMasterId;
    colorId: number;
    sizeId: number;
    colorName: string;
    sizeName: string;
    fabricSupplier?:string;
    fabricColor?:string;
    fabricNumber?:string;
    fabricUnitCostCurrencyId?:number;
    fabricUnitCostPrice?:number;
}

export interface SkuTagGeneration {
    itemName?: string;
    skuCode?: string;
    poNumber?: string;
    purchaseOrderId?: number;
    purchaseOrderSizeId?:number;
    qty?: number;
    brandId?: number;
    collectionId?: number;
    itemCategoryId?: number;
    priceCategoryId?: number;
    priceCategory?:string;
    itemCountrySellPriceId?:number;
    itemCountrySellPrices?: SkuTagGenerationSellPrice[];
}

export interface SkuTagGenerationSellPrice {
    sellPriceId: number;
    sellPriceName: string;
}

export interface PageErrors{
    currentPage?:string;
    inputQtyPagesErrors:inputQtyPageError[];
}

export interface inputQtyPageError{
    colorId:number;
    sizeId:number;
    storeId:number;
    addedQty:number;
}

export interface EpcRow
{
    check? : string;
    epc : string;
    poNUmber? : string;
    skuCode : string;
    itemName? : string;
    brandCode?:string;
    statusName? : string;
}

export interface UnexpectedEpcsInput {
    Epcs?: string[];
    PurchaseOrderIds?: number[];
}

export interface ExpectedEpcsInput
{
    checkedEPCs: string;
    purchaseOrderIds: string;
}
export interface CreateUnexpectedTagsReq {
    Epc: string
    skuCode: string
    processId: number
    processTypeCode: string
    locationId: number
    locationTypeCode: string
    poNumber: string
    status: string
}

export interface GoodsInboundRequestModel {
    palletId?:number;
    Epcs: string[];
    locationId : number;
    UnexpectedTags: CreateUnexpectedTagsReq[];
}

export interface StockAdjustmentReason {
    typeCode: string;
    reasonCode: string;
    reasonName: string;
}
export interface BrandLabel {
  id: number;
  brandLabelName: string;
  brandId: number;
  labelNumber: number;
  /** * Represented as a base64 string when coming from a JSON API, 
   * or Uint8Array if handled as raw binary data.
   */
  imageUrl?: string; // This can be a URL or a base64 string depending on your implementation
  imagePreSignedUrl?: string; // URL for directly accessing the image if stored in a service like AWS S3
createdOn?: Date;
  isActive: boolean;
}
export interface CareLabel {
  id: number;
  careLabelName: string;
  labelNumber: number;
  /** * Represented as a base64 string when coming from a JSON API, 
   * or Uint8Array if handled as raw binary data.
   */
  imageUrl?: string; // This can be a URL or a base64 string depending on your implementation
  imagePreSignedUrl?: string; // URL for directly accessing the image if stored in a service like AWS S3

  isActive: boolean;
}


export interface ImageForPreview {
    imageUrl: string;
    originalUrl: string;
    imageSize:string;
    purchaseOrderImageId:number;
};